<!-- LEFT COLUMN -->
<div
  class="left-col"
  #leftCol
  [class.column-layout]="isColumnLayout"
  [class.big-header]="
    route.firstChild && (route.firstChild.data | ngrxPush)!['context'] === 'application'
  "
  [class.primary]="!onRight && !hideLeft"
  [class.hidden]="hideLeft"
  [class.show-mobile-header]="rightOutlet?.activatedRouteData['showMobileHeader']"
  [@leftColAnimation]="leftState(onRight ? 'right' : 'left')"
  [ngClass]="{ hoaContainer: hoaDocsContainer }"
>
  <!-- HEADER CONTAINER -->
  <div class="header-container" [class.column-layout]="isColumnLayout" [shadowOnScroll]="onRight">
    <router-outlet
      #header="outlet"
      name="header"
      [outletActivationManager]="header"
    ></router-outlet>
  </div>

  <!-- LEFT OUTLET -->
  <div
    class="left-route-animation-container"
    [class.column-layout]="isColumnLayout"
    [@leftOutletTransitions]="leftOutletTransitions(left)"
  >
    <router-outlet
      name="left"
      (activate)="scrollTop()"
      #left="outlet"
      [outletActivationManager]="left"
      [class.hidden]="default.isActivated"
    ></router-outlet>

    <router-outlet
      #default="outlet"
      [outletActivationManager]="default"
      (activate)="scrollTop()"
    ></router-outlet>
  </div>

  <!-- OVERLAY -->
  @if (showOverlay((isDesktop$ | ngrxPush)!, onRight ? 'right' : 'left')) {
  <div class="overlay" [class.column-layout]="isColumnLayout" @fadeIn></div>
  }
</div>

<!-- RIGHT COLUMN -->
<div
  class="right-col"
  [class.column-layout]="isColumnLayout"
  [class.primary]="onRight || hideLeft"
  [@rightColAnimation]="rightState(onRight ? 'right' : 'left')"
>
  <!-- RIGHT OUTLET -->
  <div class="route-animation-container" [@rightOutletTransitions]="outletAnimationState(right)">
    <router-outlet
      name="right"
      #right="outlet"
      (activate)="adjustLeftScroll()"
      [outletActivationManager]="right"
    ></router-outlet>
  </div>
</div>
